export const thunkTypes = {
  LIST_QUEUE: `routeAssignment/listQueue`,
  QUERY_QUEUE: `routeAssignment/queryQueue`,
  LIST_AMBASSADORS: `routeAssignment/listAmbassadors`,
  LIST_AMBASSADOR_LOADS: `routeAssignment/listAmbassadorLoads`,
  LIST_AMBASSADOR_ZONES: `routeAssignment/listAmbassadorZones`,
  GET_DELIVERY_DETAIL: `routeAssignment/getDeliveryDetail`,
  ASSIGN_REQUEST: `routeAssignment/assignRequest`,
};
